import React from 'react';
import { Link } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to console in development
    if (process.env.NODE_ENV === 'development') {
      // Error details for debugging
      this.setState({
        error,
        errorInfo,
      });
    }

    // In production, you could log to an error reporting service here
    // Example: logErrorToService(error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  render() {
    if (this.state.hasError) {
      // Custom fallback UI
      return (
        <div className="error-boundary">
          <div className="error-boundary-container">
            <div className="error-boundary-content">
              <div className="error-boundary-icon">
                <i className="bi bi-exclamation-triangle-fill"></i>
              </div>
              <h1 className="error-boundary-title">Something went wrong</h1>
              <p className="error-boundary-message">
                We're sorry, but something unexpected happened. Please try refreshing the page or contact support if the problem persists.
              </p>
              
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <div className="error-boundary-details">
                  <details>
                    <summary className="error-boundary-details-summary">Error Details (Development Only)</summary>
                    <div className="error-boundary-details-content">
                      <pre className="error-boundary-stack">
                        {this.state.error.toString()}
                        {this.state.errorInfo?.componentStack}
                      </pre>
                    </div>
                  </details>
                </div>
              )}

              <div className="error-boundary-actions">
                <button
                  className="btn btn-primary error-boundary-btn"
                  onClick={this.handleReset}
                >
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  Try Again
                </button>
                <Link
                  to="/"
                  className="btn btn-outline-primary error-boundary-btn"
                >
                  <i className="bi bi-house me-2"></i>
                  Go Home
                </Link>
                <button
                  className="btn btn-outline-secondary error-boundary-btn"
                  onClick={() => window.location.reload()}
                >
                  <i className="bi bi-arrow-repeat me-2"></i>
                  Refresh Page
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
